import { render, staticRenderFns } from "./history-receipts.vue?vue&type=template&id=9d7ad5bc&scoped=true"
import script from "./history-receipts.vue?vue&type=script&lang=js"
export * from "./history-receipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7ad5bc",
  null
  
)

export default component.exports